import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ActionType} from "@/util/type/store";
import {EntityService} from "@/service/EntityService.ts";
import {CreateEntityRequest} from "@/model/request/entity/CreateEntityRequest.ts";
import {ReadEntity, ReadEntityResponse} from "@/model/response/entity/ReadEntityResponse.ts";
import {CreateEntityResponse} from "@/model/response/entity/CreateEntityResponse.ts";
import {CreateBulkEntityRequest} from "@/model/request/entity/CreateBulkEntityRequest.ts";
import {BaseResponse} from "@/model/response/BaseResponse.ts";
import {DeleteEntityRequest} from "@/model/request/entity/DeleteEntityRequest.ts";
import {UpdateEntity} from "@/model/request/entity/UpdateEntity.ts";
import {ReadEntityByApplicationId} from "@/model/request/entity/ReadEntityByApplicationId.ts";


export type NewEntityState = {
    loading: boolean;
    entity: ReadEntity[]
    entityById: ReadEntity[]
    selectedEntity: ReadEntity
};

const initialState: NewEntityState = {
    loading: false,
    entity: [],
    entityById: [],
    selectedEntity: {} as ReadEntity,
};

const action = {
    create: createAsyncThunk(
        "entity/create",
        async (payload: ActionType<CreateEntityRequest>, thunkAPI) => {
            return (await EntityService.create(thunkAPI, payload.data)).data;
        }
    ),
    bulkCreate: createAsyncThunk(
        "entity/bulkCreate",
        async (payload: CreateBulkEntityRequest, thunkAPI) => {
            return (await EntityService.bulkCreate(thunkAPI, payload)).data;
        }
    ),
    readByEntityApplicationId: createAsyncThunk(
        "entity/readByEntityApplicationId",
        async (payload: ReadEntityByApplicationId, thunkAPI) => {
            return (await EntityService.readByEntityApplicationId(thunkAPI, payload)).data;
        }
    ),
    update: createAsyncThunk(
        "entity/update",
        async (payload: ActionType<UpdateEntity>, thunkAPI) => {
            return (await EntityService.update(thunkAPI, payload.data)).data;
        }
    ),
    read: createAsyncThunk("entity/read", async (_, thunkAPI) => {
        return (await EntityService.read(thunkAPI)).data;
    }),
    delete: createAsyncThunk("entity/delete", async (payload: ActionType<DeleteEntityRequest>, thunkAPI) => {
        return (await EntityService.delete(thunkAPI, payload.data)).data;
    })
};

const slice = createSlice({
    name: "entity",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        setSelectedEntity(state, {payload}) {
            state.selectedEntity = payload;
        },
        reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.create.fulfilled, (state, action) => {
                const response = action.payload as CreateEntityResponse;
                state.loading = false;
                if (response.responseCode === "00")
                    action.meta.arg.onSuccess?.(action.payload);
                else {
                    action.meta.arg.onError?.(action.payload);
                }
            }).addCase(action.readByEntityApplicationId.pending, (state) => {
            state.loading = true
        }).addCase(action.readByEntityApplicationId.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as ReadEntityResponse;
            if (response.responseCode === "00") {
                state.entityById = response.data
            }
        }).addCase(action.update.pending, (state) => {
            state.loading = true
        }).addCase(action.update.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse
            state.loading = false
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.delete.pending, (state) => {
            state.loading = true
        }).addCase(action.delete.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse;
            state.loading = false
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload)
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.bulkCreate.pending, (state) => {
            state.loading = true;
        }).addCase(action.bulkCreate.fulfilled, (state, action) => {
            // const response = action.payload as BaseResponse;
            state.loading = false
            // if (response.responseCode === "00") {
            //     action.meta.arg.onSuccess?.(action.payload)
            // } else {
            //     action.meta.arg.onError?.(action.payload);
            // }
        })
            .addCase(action.read.pending, (state) => {
                state.loading = true
            }).addCase(action.read.fulfilled, (state, action) => {
            state.loading = false
            if (action.payload.responseCode === "00")
                state.entity = action.payload.data;
        });
    },
});

export const entity = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
